import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Agents categories stats DTO
 */
@CaslSubject(AppSubjectEnum.AGENT_CATEGORY)
export class AgentCategoriesStatsDto extends BaseStatsDto {}
